<template>
  <v-app-bar class="app-bg-success" app density="comfortable" flat>
    <RouterLink to="/" class="d-flex align-center app-text-white text-decoration-none">
      <span class="ml-1"><v-icon start>mdi-account-circle-outline</v-icon>{{ usuario.nombre_completo }} <v-icon>{{ iconoTurnoMostrar }}</v-icon> <span class="texto-eds_mostrar">{{ edsTurnoMostrar }}</span></span>
      <v-tooltip activator="parent" location="top">Ver Menú</v-tooltip>
    </RouterLink>

    <v-spacer></v-spacer>

    <v-menu>
      <template #activator="{ props }">
        <v-btn icon v-bind="props" class="app-text-white">
          <v-icon>mdi-menu</v-icon>
          <v-tooltip activator="parent" location="top">Otras opciones</v-tooltip>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="(configuracion, index) in configuraciones" :key="index" @click="accionMenu(configuracion)">
          <v-list-item-title>
            <v-icon class="text-success mr-2">{{ configuracion.icon }}</v-icon>
            {{ configuracion.titulo }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="dialogCerrarSesion" max-width="400" persistent>
      <v-card>
        <v-card-title class="app-bg-success app-text-white d-flex justify-space-between align-center">
          <span>¿Quiere cerrar la sesión?</span>
          <v-btn class="app-text-success" icon @click="dialogCerrarSesion = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="scrollable-card-text text-center">
          <p>Cerrar Sesión</p>
          <v-row class="mt-2">
            <v-col cols="6">
              <v-btn class="app-bg-secondary app-text-white" block @click="dialogCerrarSesion = false">
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn class="app-text-white app-bg-success" block @click="cerrarSesion()">
                Si, Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>
<script>
import store from '@/store'
import { Constantes } from '@/util/Constantes';
export default {
  data() {
    return {
      configuraciones: [
        { titulo: 'Cerrar Sesión', icon: 'mdi-logout', value: 'cerrar_sesion' }
      ],
      usuario: store.state.usuario,
      dialogCerrarSesion: false,
      iconoTurnoMostrar: '',
      edsTurnoMostrar: ''
    }
  },
  created() {
    this.verInfoTurno()
  },
  mounted() {
    //Escucha el evento personalizado
    window.addEventListener('turno-updated', this.verInfoTurno)
  },
  beforeUnmount() {
    //Limpia el listener para evitar memory leaks
    window.removeEventListener('turno-updated', this.verInfoTurno)
  },
  methods: {
    accionMenu(opcion) {
      if (opcion.value === "cerrar_sesion") {
        this.dialogCerrarSesion = true
      }
    },
    cerrarSesion() {
      const datoEnviar = {
        usuario_codigo: this.usuario.codigo
      }
      this.axios
        .post("usuario/cerrarsesion", datoEnviar)
        .then((respuesta) => {
          if (respuesta.status === 200) {
            localStorage.clear()
            window.location = '/'
          }
        })
        .catch((error) => {
          console.log(error, error);
        });
    },
    verInfoTurno(){
      const turno = localStorage.getItem('turno') !== null ? JSON.parse(localStorage.getItem('turno')) : null;
      if (turno){
        this.iconoTurnoMostrar = turno.tipo === Constantes.TURNO_TURNO1 ? 'mdi-weather-sunny' : 'mdi-weather-night'
        this.edsTurnoMostrar = turno.eds_nombre
      }
    }
  }
}
</script>
<style scoped>
.texto-eds_mostrar {
  font-size: 10px;
}
</style>